import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, navigateTo, remove } from 'kapix-components-vue3'
import ctaVousAvezDesQuestionsComponentStoreCustom from './store.custom'

const storeName = 'ctaVousAvezDesQuestionsComponent'
const customImplement: CustomStoreImplementationOptions = ctaVousAvezDesQuestionsComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function ctaVousAvezDesQuestionsComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          description: undefined as Nullable<string>,
          titre: undefined as Nullable<string>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $description (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.description,
          set: (value) => {
            this.$data.description = value
            this.$emit('update:description', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $titre (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.titre,
          set: (value) => {
            this.$data.titre = value
            this.$emit('update:titre', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async prendreRendezVousClick () {
        await navigateTo({
          name: 'Contact',
          hash: '#titre--p9'
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return ctaVousAvezDesQuestionsComponentFactory(storeId)()
}

export const ctaVousAvezDesQuestionsComponentRaw = ctaVousAvezDesQuestionsComponentFactory()
export const ctaVousAvezDesQuestionsComponent = () => ctaVousAvezDesQuestionsComponentRaw() as MergeCustomStore<typeof ctaVousAvezDesQuestionsComponentStoreCustom.instance>
